import React, { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface AdminRouteProps {
    element: JSX.Element;
    requiredRoles?: string[]; // список ролей (строк)
}

const AdminRoute: React.FC<AdminRouteProps> = ({ element, requiredRoles }) => {
    const { isAuth, roles, loading } = useAuth();

    // roles теперь: { id: number; name: string }[]
    const roleNames: string[] = (roles || []).map(r => r.name);

    if (loading) {
        return (
            <div style={{ height: "90vh", paddingTop: 100 }}>
                <div className="spinner-wrapper">
                    <div className="spinner"></div>
                </div>
            </div>
        );
    }

    if (!isAuth) {
        return <Navigate to="/login" replace />;
    }

    if (requiredRoles && requiredRoles.length > 0) {
        const hasAccess = roleNames.some(r => requiredRoles.includes(r));

        if (!hasAccess) {
            return <Navigate to="/403" replace />;
        }
    }

    return element;
};

export default AdminRoute;
